import { addWeeks, startOfWeek } from "date-fns";
import React from "react";

import { NumericalDayOfWeek } from "@whoosh/utilities/src/calendars";

import { getWeeksBetweenInclusive } from "../utils/calendarDateUtils";
import { WeekRow } from "./WeekRow";

type Props = {
  monthDateObj: Date;
  startDate: Date;
  endDate: Date;
  clubWeekStartsOn: NumericalDayOfWeek;
};

export const CalendarBody = ({
  monthDateObj,
  startDate,
  endDate,
  clubWeekStartsOn,
}: Props) => {
  const weeks = getWeeksBetweenInclusive(startDate, endDate, clubWeekStartsOn);
  if (isNaN(weeks) || weeks < 1) return null;
  return (
    <>
      {Array.from(Array(weeks).keys()).map((i) => {
        const weekStartDateObject = startOfWeek(addWeeks(startDate, i), {
          weekStartsOn: clubWeekStartsOn,
        });
        return (
          <WeekRow
            key={`week-${weekStartDateObject.toString()}`}
            monthDateObj={monthDateObj}
            startDateObj={weekStartDateObject}
          />
        );
      })}
    </>
  );
};
